const connectors = {
  addConnector: 'Ajouter un connecteur',
  cancelConnectorRun: 'Annuler l\'exécution',
  chooseConnectorType: 'Choisir un connecteur',
  connectorBillingRequired: 'Chaque exécution de connecteur coûte 0,01 $. Ajoutez un moyen de paiement avant de créer un connecteur.',
  connectorDescription_GITHUB: 'Suivre un dépôt GitHub',
  connectorDescription_STRAVA: 'Suivre un athlète Strava',
  connectorDescription_SUBSTACK: 'Suivre une publication Substack',
  connectorDescription_YOUTUBE: 'Suivre une chaîne YouTube',
  connectorFollowerCount_one: '{{count}} abonné',
  connectorFollowerCount_other: '{{count}} abonnés',
  connectorOpenIssueCount_one: '{{count}} issue ouverte',
  connectorOpenIssueCount_other: '{{count}} issues ouvertes',
  connectorOpenPullRequestCount_one: '{{count}} pull request ouverte',
  connectorOpenPullRequestCount_other: '{{count}} pull requests ouvertes',
  connectorPostCount_one: '{{count}} publication',
  connectorPostCount_other: '{{count}} publications',
  connectorRunBilledUnits_one: '{{count}} unité facturée',
  connectorRunBilledUnits_other: '{{count}} unités facturées',
  connectorRunCharge: '{{amount}} $',
  connectorRunStatus_cancelled: 'Annulé',
  connectorRunStatus_error: 'Erreur',
  connectorRunStatus_queued: 'En file d\'attente',
  connectorRunStatus_success: 'Succès',
  connectors: 'Connecteurs',
  connectorStarCount_one: '{{count}} étoile',
  connectorStarCount_other: '{{count}} étoiles',
  connectorSubscriberCount_one: '{{count}} abonné',
  connectorSubscriberCount_other: '{{count}} abonnés',
  connectorType_GITHUB: 'GitHub',
  connectorType_STRAVA: 'Strava',
  connectorType_SUBSTACK: 'Substack',
  connectorType_YOUTUBE: 'YouTube',
  connectorYtdRide_one: '{{count}} sortie vélo · {{distance}} km cette année',
  connectorYtdRide_other: '{{count}} sorties vélo · {{distance}} km cette année',
  connectorYtdRun_one: '{{count}} course · {{distance}} km cette année',
  connectorYtdRun_other: '{{count}} courses · {{distance}} km cette année',
  connectorYtdSwim_one: '{{count}} nage · {{distance}} km cette année',
  connectorYtdSwim_other: '{{count}} nages · {{distance}} km cette année',
  failedToLoadConnectors: 'Impossible de charger les connecteurs',
  githubRepository: 'Dépôt',
  noConnectorRunsToDisplay: 'Aucune exécution à afficher',
  noConnectorsMatchSearch: 'Aucun connecteur ne correspond à votre recherche',
  noConnectorsToDisplay: 'Aucun connecteur à afficher',
  noConnectorTypesMatchSearch: 'Aucun type de connecteur ne correspond à votre recherche',
  provideGitHubRepository: 'Entrez un dépôt GitHub au format owner/repo ou une URL github.com.',
  provideHandleOrChannelId: 'Entrez un identifiant de chaîne ou un ID de chaîne, pas les deux.',
  provideStravaAthlete: 'Entrez un ID d\'athlète numérique ou une URL strava.com/athletes/{id}.',
  provideSubstackUrl: 'Entrez l\'URL ou le sous-domaine d\'une publication Substack.',
  runConnector: 'Lancer le connecteur',
  searchConnectors: 'Rechercher des connecteurs',
  stravaAthlete: 'ID d\'athlète ou URL du profil',
  substackUrl: 'URL de la publication',
  youtubeChannelId: 'ID de la chaîne',
  youtubeHandle: 'Identifiant de la chaîne',
};

export default connectors;
